// removed by extract-text-webpack-plugin
module.exports = {"container":"f8_g","header":"f8_bg","alignCenter":"f8_f9","logoContainer":"f8_ga","logo":"f8_v","title":"f8_n"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/PageHeader/styles.module.css
// module id = 1348
// module chunks = 27